import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AssestsRoutingModule } from './assests-routing.module';
import { AssestsDetailsComponent } from './assests-details/assests-details.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { AssestsLandingPageComponent } from './assests-landing-page/assests-landing-page.component';
import { AssestsLinkComponent } from './assests-link/assests-link.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AssetDetailsDialogComponent } from './asset-details-dialog/asset-details-dialog.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatCardModule } from '@angular/material/card';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    AssestsDetailsComponent,
    AssestsLandingPageComponent,
    AssestsLinkComponent,
    AssetDetailsDialogComponent,
   
  ],
  imports: [
    CommonModule,
    AssestsRoutingModule,
    AcademicFormModule,
    NgxSpinnerModule.forRoot({ type: 'ball-scale-multiple' }),
    MatSelectModule,
    FormsModule ,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatCardModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule
  ]
})
export class AssestsModule { }
